import { createContext, lazy, useContext, useMemo } from "react";

import { defineFormBuilderResolver } from "../utils/define-form-builder-resolver";
import { MinimalFormField, Resolver } from "../types/form-fields";
import { mapResolvers } from "../utils/map-resolvers";

export const defaultResolversMap = {
  text: defineFormBuilderResolver<MinimalFormField>({
    type: "text",
    component: lazy(() => import("../components/internals/minimal-input-text")),
    defaultValue: "",
  }),
} as Record<string, Resolver<MinimalFormField>>;

export const FormBuilderFactoryContext = createContext({
  resolvers: defaultResolversMap,
});

export const FormBuilderFactory: React.FC<{
  resolvers: Resolver<MinimalFormField>[];
  children: React.ReactNode;
}> = ({ resolvers, children }) => {
  const resolversMap = useMemo(() => mapResolvers(resolvers), [resolvers]);

  return (
    <FormBuilderFactoryContext.Provider
      value={{
        resolvers: resolversMap,
      }}
    >
      {children}
    </FormBuilderFactoryContext.Provider>
  );
};

export const useFormBuilderFactory = () =>
  useContext(FormBuilderFactoryContext);
